var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.157,
    height: 8.133,
    viewBox: "0 0 9.157 8.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M137.054,3.551,133.747.117a.382.382,0,0,0-.656.265V2.036h-.127A4.966,4.966,0,0,0,128,7v.763a.376.376,0,0,0,.3.365.341.341,0,0,0,.084.01.4.4,0,0,0,.349-.217,4.173,4.173,0,0,1,3.753-2.32h.6V7.25a.382.382,0,0,0,.656.265l3.307-3.434a.382.382,0,0,0,0-.53Zm0,0",
    transform: "translate(-128.003 -0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardNew);
export default __webpack_public_path__ + "static/media/forward-new.3d306e7bcae15e6d2476c1289616e177.svg";
export { ForwardRef as ReactComponent };